module.exports = __webpack_public_path__ + "static/media/ds.b05bce34.jpg";